var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0587 5.49967C6.21543 5.05412 6.5248 4.67841 6.932 4.4391C7.3392 4.19978 7.81796 4.1123 8.28348 4.19215C8.749 4.272 9.17124 4.51402 9.47542 4.87536C9.77959 5.2367 9.94607 5.69402 9.94536 6.16634C9.94536 7.49967 7.94536 8.16634 7.94536 8.16634M7.9987 10.833H8.00536M14.6654 7.49967C14.6654 11.1816 11.6806 14.1663 7.9987 14.1663C4.3168 14.1663 1.33203 11.1816 1.33203 7.49967C1.33203 3.81778 4.3168 0.833008 7.9987 0.833008C11.6806 0.833008 14.6654 3.81778 14.6654 7.49967Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle2);
export default __webpack_public_path__ + "static/media/help-circle_2.75601aaee6d9926c661540f22261e29c.svg";
export { ForwardRef as ReactComponent };